import AbstractViewManage from '@/class/view/AbstractViewManage'
import { cacheName, cache } from '@/utils/cacheManager'
import * as LoadDefaultQueryParam from '@/utils/LoadDefaultQueryParam'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { getBillingList, batchUnConfirmBilling, simpleQueryBillingList } from '@/api/clearing/billingNative'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import lodash from 'lodash'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'
import ColumnUtils from '@/utils/ColumnUtils'
import { formatNumberToThousands } from '@/utils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { recordSelectedStatus } from '@/utils/agGrid'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { stringToBool } from '@/utils/commonUtil'
import $store from '@/store'

// 本文件中除了unConfirmBilling以外的方法其余均为“结算模块-开票/收票-按账单”查询时所使用，
export default class tabBillingHP extends AbstractViewManage {
  constructor(view) {
    super(view)
  }

  // 公用显示列
  dynamicColumnDefs() {
    return [
      {
        headerName: '', width: 60, checkboxSelection: true,
        sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        headerCheckboxSelection: true
      },
      { headerName: this.$t('Billing.billingJob_billNo'), field: 'billingNo', width: 200, enableRowGroup: true },
      { headerName: this.$t('Billing.billingJob_accountStatementNo'), field: 'billingGroupBillingNo', width: 200, enableRowGroup: true },
      { headerName: this.$t('Billing.billingJob_settlementAgent'), field: 'settlementAgentId', width: 200,
        cellRenderer: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_accountId')
        },
        hide: true
      },
      { headerName: this.$t('Billing.billingJob_agentBillNo'), field: 'counterPartyBillingNo', width: 200, enableRowGroup: true },
      { headerName: this.$t('Billing.billingJob_invoiceNo'), field: 'invoiceNo', width: 200, hide: true, enableRowGroup: true },
      { headerName: this.$t('Billing.billingView_billType'), field: 'billingType', width: 200, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.billingTypeLabFun(params.value)
        }
      },
      { headerName: this.$t('Billing.billingJob_revenueAndExpenditureType'), field: 'ar', width: 200, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.chargeReceivableLabelFun(stringToBool(params.value))
        } },
      { headerName: this.$t('Billing.billingJob_billDate'), field: 'inputDate', width: 200, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        } },
      { headerName: this.$t('Billing.billingJob_invoiceHeader'), field: 'title', width: 200, enableRowGroup: true },
      { headerName: this.$t('Billing.billingJob_invoicingRequirements'),
        field: 'invoiceDemand', width: 200, enableRowGroup: true,
        tooltip: (params) => {
          return params.data.invoiceDemand
        }
      },
      { headerName: this.$t('Billing.billingJob_confirmDate'),
        field: 'billingConfirmDate', width: 200, enableRowGroup: true
      },
      { headerName: this.$t('Billing.billingJob_settleAccountsTo'), field: 'accountId', width: 200, enableRowGroup: true,
        cellRenderer: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_accountId')
        } },
      { headerName: this.$t('Billing.billingJob_solicitationType'), field: 'jobCargoSource', width: 200, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.cargoSourceLabelFunction(params.value)
        } },
      { headerName: 'ETD', field: 'jobEtd', width: 120, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: 'ETA', field: 'jobEta', width: 120, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: 'ATD', field: 'jobAtd', width: 120, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: 'ATA', field: 'jobAta', width: 120, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: this.$t('Billing.billingJob_proofDate'), field: 'voucherExportDate', width: 200, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        },
        hide: this._view.showColumnsVisible.showVoucherDate
      },
      {
        headerName: this.$t('Partners.isFba'),
        colId: 'fba',
        field: 'fba',
        width: 180,
        hide: true,
        enableRowGroup: true,
        valueFormatter: (params) => {
          return ColumnUtils.booleanLabelFunction(Number(params.value))
        }
      },
      {
        headerName: this.$t('baseInfo.mailingAddress.fbaWarehouseCode'),
        colId: 'warehouseCode',
        field: 'warehouseCode',
        width: 180,
        enableRowGroup: true,
        hide: true
      },
      {
        headerName: this.$t('FbaJob.DestinationDistribution'),
        colId: 'destinationDistribution',
        field: 'destinationDistribution',
        width: 180,
        hide: true,
        enableRowGroup: true,
        valueFormatter: (params) => {
          return ColumnUtils.multipleFbaDestinationDistribution(TYPE_NAMES.local_cache_FbaJobConstants$DESTINATION_DISTRIBUTION_LIST, 'code', params.value)
        }
      },
      {
        headerName: this.$t('FbaJob.ExpressNo'),
        colId: 'expressNo',
        field: 'expressNo',
        width: 180,
        enableRowGroup: true,
        hide: true
      },
      {
        headerName: this.$t('FbaJob.RemoteWarehouse'),
        colId: 'remoteWarehouse',
        field: 'remoteWarehouse',
        width: 180,
        hide: true,
        enableRowGroup: true,
        valueFormatter: (params) => {
          return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
        }
      },
      {
        headerName: 'Shipment Id',
        colId: 'shipmentId',
        field: 'shipmentId',
        width: 180,
        enableRowGroup: true,
        hide: true
      },
      {
        headerName: 'Reference Id',
        colId: 'referenceId',
        field: 'referenceId',
        width: 180,
        enableRowGroup: true,
        hide: true
      },
      { headerName: this.$t('Billing.billingJob_businessNumber'), field: 'jobNo', width: 200, enableRowGroup: true,
        cellRendererFramework: 'agGridColumnEdit',
        custom: {
          tag: 'router-and-print',
          attrs: {
            useRoute: true,
            usePrint: false,
            routeName: 'FinanceManage',
            routeParamKeys: { jobNo: 'jobNo' },
            routeTitle: this.$t('Clearing.FinancialAudit'),
            routePermissions: ['module_ACVerify'],
            extraRouteParams: {},
            printMethod: () => {}
          }
        }},
      { headerName: this.$t('Billing.billingJob_separateNumber'), field: 'jobHbl', width: 200, hide: true, enableRowGroup: true },
      { headerName: this.$t('Billing.billingJob_mblNo'), field: 'jobMbl', width: 200, enableRowGroup: true },
      { headerName: this.$t('Billing.billingJob_vesselAndVoyage'), field: 'voyageFlight', width: 200, enableRowGroup: true },
      { headerName: this.$t('Billing.billingJob_portOfLoading'), field: 'pol', width: 200, enableRowGroup: true },
      { headerName: this.$t('Billing.billingJob_portOfDestination'), field: 'pod2', width: 200, enableRowGroup: true },
      { headerName: this.$t('Billing.billingJob_creator'), field: 'inputBy', width: 200, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        } },
      { headerName: this.$t('Billing.billingJob_customerService'), field: 'jobCsr', width: 200, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        } },
      { headerName: this.$t('Billing.billingJob_customJobType'), field: 'jobCustomJobType', width: 200, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.value, 'name')
        },
        hide: true
      },
      { headerName: this.$t('Billing.billingJob_billStatus'), field: 'state', width: 200, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.billingStateLabelFun(Number(params.value))
        } },
      { headerName: this.$t('Billing.billingJob_invoicingStatus'), field: 'invoiceState', width: 200, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.invoiceStateLabelFun(Number(params.value))
        },
        hide: this._view.showColumnsVisible.showInvoiceState
      },
      { headerName: this.$t('Billing.billingJob_writeOffStatus_bill'), field: 'realClearingState', width: 200, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.clearingStateLabFun(Number(params.value))
        },
        hide: this._view.showColumnsVisible.showRealClearingState
      },
      { headerName: this.$t('Billing.billingJob_currency'), field: 'currency', width: 200, enableRowGroup: true },
      { headerName: this.$t('Billing.billingJob_amountOfMoney'), field: 'amount', width: 200, enableRowGroup: true,
        cellRenderer: (params) => {
          return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('Billing.billingJob_aging'), field: 'aging', width: 200, enableRowGroup: true },
      { headerName: this.$t('Billing.billingJob_theAmountOfWriteOffs'), field: 'verifiedAmount', width: 200, enableRowGroup: true,
        cellRenderer: (params) => {
          return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
        },
        hide: this._view.showColumnsVisible.showVerifiedAmount,
        summaryMode: 'sum'
      },
      { headerName: this.$t('Billing.billingJob_notInvoicedMoney'), field: 'uninvoiceAmount', width: 200, enableRowGroup: true,
        cellRenderer: (params) => {
          return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
        },
        hide: this._view.showColumnsVisible.showUnInvoiceAmount,
        summaryMode: 'sum'
      },
      { headerName: this.$t('Billing.billingJob_totalCurrency'), field: 'currencyAmount', width: 200, enableRowGroup: true,
        summaryMode: 'sum' },
      { headerName: this.$t('Billing.billingJob_remarks'), field: 'remark', width: 200, enableRowGroup: true },
      { headerName: this.$t('Billing.billingJob_bookingNo'), field: 'bookingNo', width: 200, enableRowGroup: true },
      { headerName: this.$t('Billing.billingJob_markDate'), field: 'markDate', width: 200, enableRowGroup: true },
      { headerName: this.$t('Billing.billingJob_markUser'), field: 'markUser', width: 200, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        } },
      { headerName: this.$t('Billing.billingJob_markStatus'), field: 'mark', width: 200, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.markingStateLabelFun(stringToBool(params.value))
        } },
      { headerName: this.$t('Billing.billingJob_theAmountOfNotWriteOffs'), field: 'unverifiedAmount', width: 200, enableRowGroup: true,
        cellRenderer: (params) => {
          return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
        },
        summaryMode: 'sum' },
      {
        headerName: this.$t('Billing.billingJob_sales'),
        field: 'sales',
        width: 200,
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        }, hide: true
      },
      {
        headerName: this.$t('Billing.billingCharge_consignationCompany'),
        field: 'customerId',
        width: 200,
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
        }, hide: true
      },
      {
        headerName: this.$t('CargoMsg.Cargo_InvoiceType'), field: 'invoiceType', colId: 'invoiceType', width: 120, enableRowGroup: true, hide: true
      },
      {
        headerName: this.$t('Invoice.invoice_invoiceCategory'), field: 'invoiceMakeType', colId: 'invoiceMakeType', width: 120, enableRowGroup: true, hide: true
      },
      { headerName: this.$t('Billing.billingCharge_operation'), field: 'jobOp', width: 200, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        }
      },
      {
        headerName: this.$t('CargoMsg.Carge_BillingConfirmUser'),
        field: 'billingConfirmUser',
        initialWidth: 200,
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        }
      },
      {
        headerName: this.$t('queryJob.placeOfDelivery'), field: 'destinationPlace', initialWidth: 200, hide: true, enableRowGroup: true
      },
      { headerName: 'S/O No.', field: 'soNo', hide: true, width: 100, enableRowGroup: true,
        valueFormatter: (params) => {
          return ColumnUtils.soNoLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_InvalidOrNot'),
        field: 'revoked',
        width: 120,
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_ConfirmOrNot'), field: 'confirmed', colId: 'confirmed', width: 120, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
        }
      },
      {
        headerName: this.$t('SeaExport.CustomerLevel'),
        colId: 'customerTypeId',
        field: 'customerTypeId',
        width: 150,
        hide: true,
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CustomerType, 'typeId', params.value, 'chineseName')
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_CooperateBranchId'),
        colId: 'cooperatebranch',
        field: 'cooperatebranch',
        width: 160, minWidth: 160,
        enableRowGroup: true,
        hide: !this._view.useOrderCenterMode
      }, {
        headerName: this.$t('CargoMsg.Cargo_CooperateBusinessType'),
        colId: 'cooperateBusinessType',
        field: 'cooperateBusinessType',
        width: 200, minWidth: 200,
        enableRowGroup: true,
        hide: !this._view.useOrderCenterMode
      }, {
        headerName: this.$t('Billing.billing_recheckStatus'),
        field: 'review',
        colId: 'review',
        hide: true,
        width: 150,
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.billingReviewLabelFunc(Number(params.value))
        }
      }, {
        headerName: this.$t('Billing.billing_reviewPeople'),
        field: 'reviewBy',
        width: 200,
        enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        }
      }, {
        headerName: this.$t('Billing.billing_reviewDate'),
        field: 'reviewDate',
        width: 200,
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('Billing.billingJob_carrier'), field: 'jobCarrierId', enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
        }, width: 150
      },
      {
        headerName: this.$t('CargoMsg.Cargo_dispatchingPlace2'),
        field: 'jobDispatchingPlace',
        colId: 'jobDispatchingPlace',
        enableRowGroup: true,
        width: 120
      },
      {
        headerName: this.$t('CargoMsg.Cargo_actTakeTime'),
        field: 'actTakeTime',
        colId: 'actTakeTime',
        width: 120,
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_ApprovalStatus'),
        field: 'approvalStatus',
        width: 100,
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.approvalStatusLabelFun(Number(params.value))
        },
        hide: true
      },
      {
        headerName: this.$t('FinanceManage.CostType'),
        colId: 'costControlType',
        field: 'costControlType',
        width: 120,
        valueFormatter: (params) => {
          const isZh = $store.getters.language === 'zh'
          return ColumnUtils.resolveCostType(params.value, isZh ? 'chineseName' : 'englishName')
        },
        enableRowGroup: true
      }
    ]
  }
  // 追加自定义查询条件
  async changeCustomSearchItems() {
    const defaultSearchFields = []
    // 账单业务状态配置项
    const billingJobStates = await LoadDefaultQueryParam.getConfigQueryParam(this._view.searchConditions.billingJobStateParam, SystemConstants.JOB_STATES)
    if (billingJobStates && billingJobStates.length > 0) {
      const searchField = new AdvancedSearchField()
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.defaultValue = []
      searchField.itemLabel = 'Billing.billingCharge_businessStatus'
      searchField.itemName = 'job.JOB_STATE'
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.dataProvider = billingJobStates
      searchField.action = 2
      defaultSearchFields.push(searchField.formatObj2Json())
      if (this._view.viewSource === 'tabMakeInvoice') {
        this._view.billingJobStates = billingJobStates
      }
    }
    // 账单状态配置项
    const billingStates = await LoadDefaultQueryParam.getConfigQueryParam(this._view.searchConditions.billingStateParam, BillingConstants.BILLING_STATES)
    if (billingStates && billingStates.length > 0) {
      const searchField = new AdvancedSearchField()
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.defaultValue = []
      searchField.itemLabel = 'Billing.billingJob_billStatus'
      searchField.itemName = 'billing.STATE'
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.dataProvider = billingStates
      searchField.action = 2
      defaultSearchFields.push(searchField.formatObj2Json())
    }
    // CARGO-37600 H5 BUG 筛选条件保存多个无法保存成功
    // // 账单确认人
    // const searchField = new AdvancedSearchField()
    // searchField.action = AdvancedSearchField.UPDATE_ACTION
    // searchField.itemType = 'advanceSelect'
    // searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
    // searchField.itemName = 'billing.CONFIRM_USER'
    // searchField.itemLabel = 'CargoMsg.Carge_BillingConfirmUser'
    // searchField.tagValue = 'userId'
    // searchField.defaultSelected = 0
    // searchField.subType = { filterable: true }
    // searchField.dataProvider = getCacheListByKey(basicCacheKeys.basic_data_User)
    // defaultSearchFields.push(searchField.formatObj2Json())
    if (this._view.useOrderCenterMode) {
      const officeAll = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
      const offices = officeAll.filter(p => p.code !== 'HQ').sort((office1, office2) => office1.officeId > office2.officeId ? 1 : -1)
      offices.forEach(row => { row.code = row.officeId }) // ID
      let searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
      searchField.defaultConditionVal = 0
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'cooperate.BRANCH_ID'
      searchField.itemLabel = 'CargoMsg.Cargo_CooperateBranchId'
      searchField.itemValue = []
      searchField.tagValue = 'officeId'
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = offices
      defaultSearchFields.push(searchField.formatObj2Json())
      // 协作业务类型
      const cooperationTypes = getCacheListByKey(basicCacheKeys.basic_data_CooperationType)
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
      searchField.defaultConditionVal = 0
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'cooperate.BUSINESS_TYPE'
      searchField.itemLabel = 'CargoMsg.Cargo_CooperateBusinessType'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = cooperationTypes
      defaultSearchFields.push(searchField.formatObj2Json())
    }
    if (defaultSearchFields && defaultSearchFields.length > 0) {
      this._view.customSearchItems = defaultSearchFields
    }
  }

  // 列表查询（高级conditions是查询条件/快捷检索conditions代表是键盘输入的值）
  fetchData({ simpleTriggerMode, conditions }) {
    const finallyConditions = []
    if (simpleTriggerMode) {
      if (this._view.viewSource === 'tabBilling') {
        this._view.appendQuery = false
        const option = new AdvancedSearchOption(null, 'billing.BILLINGNO', conditions.trim(), OperatorConstants.OPERATOR_LIKE.code)
        finallyConditions.push(option.formatObj2Json())
      }
    } else {
      // 高级查询条件组装
      if (conditions && conditions.length > 0) {
        const advConditions = lodash.cloneDeep(conditions)
        // 获取追加查询条件
        this._view.appendQuery = JobUtils.appendQueryCondition(advConditions)
        finallyConditions.push(...advConditions)
      }
    }
    this._view.showLoading = true
    if (this._view.pageMode === 0) {
      this._view.searchConditions.snapshotConditionsBilling = lodash.cloneDeep(finallyConditions)
    } else {
      this._view.searchConditionsHedge.snapshotConditionsBilling = lodash.cloneDeep(finallyConditions)
    }
    this.toAdvQueryList(finallyConditions, simpleTriggerMode)
  }

  // 拼接查询条件并发起请求
  async toAdvQueryList(conditions, simpleTriggerMode = false, queryMasterDb = false) {
    await cache.load(cacheName.CONFIG)
    // 拼接默认的查询条件
    let searchConditions = []
    if (this._view.viewSource === 'tabBilling') {
      searchConditions = this._view.searchConditions
    } else {
      if (this._view.pageMode === 0) {
        searchConditions = this._view.searchConditions
      } else {
        searchConditions = this._view.searchConditionsHedge
      }
    }
    let inputDate = ''
    if (searchConditions.inputDateStart && searchConditions.inputDateEnd) {
      inputDate = 'start=' + searchConditions.inputDateStart + ' 00:00:00' + ',end=' + searchConditions.inputDateEnd + ' 23:59:59'
    } else if (searchConditions.inputDateStart && !searchConditions.inputDateEnd) {
      inputDate = 'start=' + searchConditions.inputDateStart + ' 00:00:00'
    } else if (!searchConditions.inputDateStart && searchConditions.inputDateEnd) {
      inputDate = 'end=' + searchConditions.inputDateEnd + ' 23:59:59'
    }
    if (inputDate) {
      const condition = new AdvancedSearchOption(null, 'billing.INPUTDATE', inputDate + ',type=date', OperatorConstants.OPERATOR_RANGE.code)
      conditions.push(condition.formatObj2Json())
    }
    // 内结
    if (searchConditions.internalCharge) {
      const condition = new AdvancedSearchOption(null, 'charge.INTERNAL', true, OperatorConstants.OPERATOR_EQUAL.code)
      conditions.push(condition.formatObj2Json())
    }
    if (searchConditions.paymentType !== -1) {
      const condition = new AdvancedSearchOption(null, 'billing.AR', searchConditions.paymentType === 1, OperatorConstants.OPERATOR_EQUAL.code)
      conditions.push(condition.formatObj2Json())
    }
    if (searchConditions.advance !== -1) {
      const condition = new AdvancedSearchOption(null, 'charge.ADVANCE', searchConditions.advance === 1, OperatorConstants.OPERATOR_EQUAL.code)
      conditions.push(condition.formatObj2Json())
    }
    if (searchConditions.isNeedInvoice !== -1) {
      const condition = new AdvancedSearchOption(null, 'charge.NEED_INVOICE', searchConditions.isNeedInvoice === 1, OperatorConstants.OPERATOR_EQUAL.code)
      conditions.push(condition.formatObj2Json())
    }
    if (searchConditions.hasInvoice !== -1 && !AdvancedSearchOption.hasField('charge.INVOICE_UUID', conditions) && !AdvancedSearchOption.hasField('invoice.INVOICEDATE', conditions)) {
      const operator = searchConditions.hasInvoice === 0 ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code
      const condition = new AdvancedSearchOption(null, 'charge.INVOICE_UUID', null, operator)
      conditions.push(condition.formatObj2Json())
    }
    if (searchConditions.chargeTypeGroup === 0) {
      const condition = new AdvancedSearchOption(null, 'billing.BILLINGTYPE', '国内账单', OperatorConstants.OPERATOR_EQUAL.code)
      conditions.push(condition.formatObj2Json())
    } else if (searchConditions.chargeTypeGroup === 1) {
      const condition = new AdvancedSearchOption(null, 'billing.BILLINGTYPE', '国外账单', OperatorConstants.OPERATOR_EQUAL.code)
      conditions.push(condition.formatObj2Json())
    } else {
      const condition = new AdvancedSearchOption(null, 'billing.BILLINGTYPE', ['国外账单', '国内账单'], OperatorConstants.OPERATOR_IN.code)
      conditions.push(condition.formatObj2Json())
    }
    // 账单状态
    if (!AdvancedSearchOption.hasField('billing.STATE', conditions)) {
      if (this._view.billingStates && this._view.billingStates.length > 0) {
        const billingStateArray = LoadDefaultQueryParam.convertCommonStateToInt(this._view.billingStates)
        const condition = new AdvancedSearchOption(null, 'billing.STATE', billingStateArray, OperatorConstants.OPERATOR_IN.code)
        conditions.push(condition.formatObj2Json())
      }
    }
    // 业务状态
    if (!AdvancedSearchOption.hasField('job.JOB_STATE', conditions)) {
      if (this._view.billingJobStates && this._view.billingJobStates.length > 0) {
        const jobStates = LoadDefaultQueryParam.convertCommonStateToInt(this._view.billingJobStates)
        const condition = new AdvancedSearchOption(null, 'job.JOB_STATE', jobStates, OperatorConstants.OPERATOR_IN.code)
        conditions.push(condition.formatObj2Json())
      }
    }
    // 核销状态 0:有未销账 1:有已销账 2:全部销完
    if (searchConditions.billingClearingState !== -1) {
      if (searchConditions.billingClearingState === ClearingConstants.CLEARING_STATE_NON.code || searchConditions.billingClearingState === ClearingConstants.CLEARING_STATE_PARTIAL.code) {
        const condition = new AdvancedSearchOption(null, 'charge.PAID_OFF', false, OperatorConstants.OPERATOR_UNEQUAL.code)
        conditions.push(condition.formatObj2Json())
      } else if (searchConditions.billingClearingState === ClearingConstants.CLEARING_STATE_FULL.code) {
        const condition = new AdvancedSearchOption(null, 'billing.CLEARING_STATE', 2, OperatorConstants.OPERATOR_UNEQUAL.code)
        conditions.push(condition.formatObj2Json())
      }
    }
    if (searchConditions.selectedEntitiesForHedging && searchConditions.selectedEntitiesForHedging.length > 0) {
      const condition = new AdvancedSearchOption(null, 'selectedEntitiesForHedging', searchConditions.selectedEntitiesForHedging)
      conditions.push(condition.formatObj2Json())
    }
    if (searchConditions.exceptKeys.length > 0) {
      const condition = new AdvancedSearchOption(null, 'billing.UUID', searchConditions.exceptKeys, OperatorConstants.OPERATOR_NOT_IN.code)
      conditions.push(condition.formatObj2Json())
    }

    const isAging = AdvancedSearchOption.getOption('billing.ETD', conditions)
    if (isAging) {
      const day = isAging.value
      const nowDate = new Date()
      const searcherDate = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() - day)
      isAging.value = searcherDate.getFullYear() + '-' + (Number(searcherDate.getMonth()) + 1) + '-' + searcherDate.getDay()
      const condition = new AdvancedSearchOption(isAging.fieldType, isAging.fieldName, isAging.value, isAging.operator)
      AdvancedSearchOption.removeOption(isAging.fieldName, conditions)
      conditions.push(condition.formatObj2Json())
    }
    // 是否有应付受控费用权限
    const isControlled = this.$checkPermission(['button_Charge_controlled'])
    // 是否有应收受控费用权限
    const isCostControlled = this.$checkPermission(['button_Charge_costControlled'])
    let value = 0
    if (!isControlled && !isCostControlled) {
      value = 1
    } else if (!isControlled) {
      value = 2
    } else if (!isCostControlled) {
      value = 3
    }
    if (value !== 0) {
      const option = new AdvancedSearchOption(null, 'cIsControlled', value, OperatorConstants.OPERATOR_EQUAL.code)
      conditions.push(option.formatObj2Json())
    }
    const requires = []
    if (!this._view.showColumnsVisible.showVerifiedAmount || !this._view.showColumnsVisible.showRealClearingState) { requires.push('writeoff') }
    if (!this._view.showColumnsVisible.showInvoiceState || !this._view.showColumnsVisible.showUnInvoiceAmount) { requires.push('invoice') }
    if (!this._view.showColumnsVisible.showVoucherDate) { requires.push('voucherDate') }
    if (!this._view.showColumnsVisible.showInvoiceNo) { requires.push('invoiceNo') }
    if (!this._view.showColumnsVisible.showFba) { requires.push('fba') }

    const requestBody = { conditions, requires: requires, branchId: this.$store.getters.currentOfficeId }

    if (this._view.pageMode === 0) {
      requestBody.pageNum = this._view.searchConditions.pageNumBillingGrid
      requestBody.pageSize = this._view.searchConditions.pageSize
    } else {
      requestBody.pageNum = this._view.searchConditionsHedge.pageNumBillingGrid
      requestBody.pageSize = this._view.searchConditionsHedge.pageSize
    }
    if (this._view.showLoading) {
      this.loading()
    }

    requestBody.queryMasterDb = queryMasterDb || false
    if (simpleTriggerMode) { // 是否快捷查询
      const selectedStatus = recordSelectedStatus(this._view.gridOptions.api, 'uuid')
      simpleQueryBillingList(requestBody).then(res => {
        this.handleInvoiceResult(res)
        selectedStatus.revert()
      }).finally(() => {
        if (this._view.showLoading) {
          this.closeLoading()
        }
      })
    } else {
      requestBody.appendQuery = this._view.appendQuery
      const selectedStatus = recordSelectedStatus(this._view.gridOptions.api, 'uuid')
      if (this._view.isBpmEnabled) {
        requestBody.requires = [...requestBody.requires, 'bpm']
      }
      getBillingList(requestBody).then(res => {
        this.handleInvoiceResult(res)
        selectedStatus.revert()
      }).finally(() => {
        if (this._view.showLoading) {
          this.closeLoading()
        }
      })
    }
  }
  // 开票-按账单查询结果集处理
  handleInvoiceResult(res) {
    let results = res.data.list
    if (results && results.length > 0) {
      if (this._view.pageMode === 0) {
        // 追加查询数据去重
        if (this._view.appendQuery) {
          results = JobUtils.appendQueryRepeat(this._view.billingGrid.rowData, results, this._view.appendQuery)
        }
        this._view.billingGrid.rowData = results
        this._view.searchConditions.totalBillingGrid = this._view.appendQuery ? results.length : Number(res.data.total)

        this._view.totalAmountToCurrencyBillingGrid.dataProvider = this._view.billingGrid.rowData
        this._view.totalAmountToCurrencyBillingGrid.selectedCount = 0
      } else {
        // 追加查询数据去重
        if (this._view.appendQuery) {
          results = JobUtils.appendQueryRepeat(this._view.billingGridHedge.rowData, results, this._view.appendQuery)
        }
        this._view.billingGridHedge.rowData = results
        this._view.searchConditionsHedge.totalBillingGrid = this._view.appendQuery ? results.length : Number(res.data.total)

        this._view.totalAmountToCurrencyBillingGridHedge.dataProvider = this._view.billingGridHedge.rowData
        this._view.totalAmountToCurrencyBillingGridHedge.selectedCount = 0
      }
    } else {
      if (this._view.appendQuery) return // 如果是追加查询的话就不走下面的清空代码
      if (this._view.pageMode === 0) {
        this._view.billingGrid.rowData = []
        this._view.searchConditions.totalBillingGrid = 0

        this._view.totalAmountToCurrencyBillingGrid.dataProvider = []
        this._view.totalAmountToCurrencyBillingGrid.selectedCount = 0
      } else {
        this._view.billingGridHedge.rowData = []
        this._view.searchConditionsHedge.totalBillingGrid = 0

        this._view.totalAmountToCurrencyBillingGridHedge.dataProvider = []
        this._view.totalAmountToCurrencyBillingGridHedge.selectedCount = 0
      }
    }
  }
  // 取消确认账单
  unConfirmBilling(keys) {
    this.$confirm(this.$t('Message.CancelConfirmBill'), this.$t('common.tips.prompt'), {
      confirmButtonText: this.$t('common.btn.yes'),
      cancelButtonText: this.$t('common.btn.no'),
      type: 'warning',
      distinguishCancelAndClose: true
    }).then(() => {
      batchUnConfirmBilling(keys, true, this._view.location).then(res => {
        this.$message.success(this.$t('act.billing.cancelConfirmSuccess'))
        if (this._view.viewSource === 'tabBilling') {
          this.$refs.queryBilling.toAdvQueryList(this.$refs.queryBilling.searchConditions.snapshotConditions)
        } else {
          this.toAdvQueryList(this._view.searchConditions.snapshotConditionsBilling)
        }
      }).finally(() => {
      })
    }).catch((e) => {
      if (e === 'cancel') {
        batchUnConfirmBilling(keys, false, this._view.location).then(res => {
          this.$message.success(this.$t('act.billing.cancelConfirmSuccess'))
          if (this._view.viewSource === 'tabBilling') {
            this.$refs.queryBilling.toAdvQueryList(this.$refs.queryBilling.searchConditions.snapshotConditions)
          } else {
            this.toAdvQueryList(this._view.searchConditions.snapshotConditionsBilling)
          }
        }).finally(() => {
        })
      }
    })
  }
}
